<template>
  <el-dialog
    title="投诉求职者"
    :visible.sync="visible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    center
  >
    <el-form
      class="form"
      ref="form"
      :model="form"
      :rules="rules"
      size="medium"
    >
      <el-form-item label="投诉原因" prop="complaint_type">
        <el-radio-group v-model="form.complaint_type">
          <template v-for="(item,i) in complainList">
            <div :key="i"><el-radio style="margin-top:10px" :label="item.id">{{item.title}}</el-radio></div>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="投诉描述" prop="description">
        <el-input v-model="form.description" placeholder="请描述与应聘者的沟通记录或投诉原因" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="投诉凭证" prop="file_list">
        <br/>
        <div class="tip">请上传与应聘者沟通的聊天记录截图、通话记录截图等相关凭证，可大大加快处理速度哦！</div>
        <el-upload
          :action="baseUrl + 'hunter-files'"
          :headers="{ 'Authorization': 'Bearer ' + token }"
          :on-success="uploadFilesSuccess"
          :on-remove="uploadFilesRemove"
          :limit="1"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm()" size="medium">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" size="medium">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BaseDialog from "../BaseDialog";
// import { getToken } from '@/utils'

export default {
  name: 'ComplainDialog',
  extends: BaseDialog,
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      // token: getToken('token'),
      token:'',
      form: {
        complaint_type: '',
        description: '',
        file_list: [],
      },
      rules: {
        complaint_type: [ { required: true, message: "请选择投诉原因", trigger: "change" } ],
      },
      fileList: [],
      id: 0,
      complainList: [],
    }
  },
  mounted() {
    // this.getComplaintTypes()
  },
  methods: {
    async getComplaintTypes() {
      let res = await this.$api.PartTimeApi.getComplainType()
      this.complainList = res.filter( x => { return x.type === 1 })
    },
    uploadFilesRemove(file, fileList) {
      this.form.file_list = []
      fileList.forEach( x => {
        this.form.file_list.push(x.response.key)
      })
    },
    uploadFilesSuccess(response, file, fileList) {
      console.log(response);
      this.form.file_list.push(response.key)
    },
    open(id) {
      this.visible = true
      this.id = id
    },
    submitForm(formName) {
      this.$refs[formName].validate( async (valid) => {
        console.log(this.form);
        if (valid) {
          this.form.post_id = this.id
          console.log( this.form, 11111111);
          let res = await this.$api.PartTimeApi.complaint(this.form)
          if(res) {
            this.$message.success('投诉成功')
            this.close();
            this.callback && this.callback()
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.visible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.form {
  width: 90%;
  margin: 0 auto;
  .tip {
    color: #aaa;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
